import React from 'react'
import { useStyles } from './ChurnedSubscriptionsChart.styles'
import { useTheme } from '@mui/material/styles'
import { TotalAndPercentage } from '../TotalAndPercentage/TotalAndPercentage'
import { CustomLegends } from '../CustomLegends/CustomLegends'
import { BarChartComponent } from '../../../common/components/BarChartComponent/BarChartComponent'
import { themeForRevenueLineGraph } from '../RevenueOverviewChart/RevenueOverviewChart.styles'
import { useSelector } from '../../../store/hooks'
import { Overview } from '../../../modules/flyoutOverview/types'
import { getGraphDateLabel } from '../../../common/utils/getGraphDateLabel'
import { OverviewEmptyState } from '../OverviewEmptyState/OverviewEmptyState'
import OverviewEmptyStateImage from '../../../common/images/overviewEmptyState.png'

export const ChurnedSubscriptionsChart = ({
  dateRangeDescription,
}: {
  dateRangeDescription: string
}) => {
  const { classes } = useStyles()
  const theme = useTheme()
  const lineGraphTheme = themeForRevenueLineGraph(
    theme.palette.labraText.description
  )
  const { churnedSubscription } = useSelector<Overview>(
    state => state.flyoutOverview?.overview
  )
  const isChurnedSubscriptionDataEmpty =
    !churnedSubscription?.data || churnedSubscription.data.length === 0

  const activeSubscriptionList = churnedSubscription?.data?.map(
    subscriptionItem => ({
      aws: subscriptionItem?.aws,
      microsoft: subscriptionItem?.microsoft,
      gcp: subscriptionItem?.gcp,
      month: getGraphDateLabel(subscriptionItem?.date),
    })
  )

  return (
    <>
      {isChurnedSubscriptionDataEmpty ? (
        <OverviewEmptyState
          imgUrl={OverviewEmptyStateImage}
          containerHeight={19.25}
          imageHeight={12}
          imageWidth={16.75}
          description="No churned subscription on your product(s) exist right now."
        />
      ) : (
        <div
          data-testid={'churned-subscriptions-chart'}
          className={classes.root}
        >
          <TotalAndPercentage
            total={churnedSubscription?.total}
            percentage={churnedSubscription?.percentage}
            type={churnedSubscription?.rise}
            label="in last 1 year"
          />
          <div
            className={classes.legendsWrapper}
            data-testid={'custom-legend-wrapper'}
          >
            <CustomLegends
              legends={[
                {
                  label: 'AWS',
                  legendColor: theme.palette.awsGraph.main,
                  legendSize: 'medium',
                },
                {
                  label: 'Microsoft',
                  legendColor: theme.palette.microsoftGraph.main,
                  legendSize: 'medium',
                },
                {
                  label: 'GCP',
                  legendColor: theme.palette.gcpGraph.main,
                  legendSize: 'medium',
                },
              ]}
            />
          </div>
          <div data-testid={'churned-subscriptions-bar-chart'}>
            <BarChartComponent
              classes={classes}
              data={activeSubscriptionList}
              keys={['aws', 'microsoft', 'gcp']}
              indexBy="month"
              theme={lineGraphTheme}
              colors={[
                theme.palette.awsGraph.main,
                theme.palette.microsoftGraph.main,
                theme.palette.gcpGraph.main,
              ]}
              gridYValues={2}
              axisBottomLegend={`(${dateRangeDescription})`}
              showToolTip={true}
              leftTickValues={2}
            />
          </div>
        </div>
      )}
    </>
  )
}
